export default __webpack_public_path__ + "static/media/dlc-clip.9c322f31.png";